export default __webpack_public_path__ + "static/media/F_Fada.9371d337.svg";